import { Injectable } from '@angular/core';
import { FormGroup, AbstractControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormValidationService {

  // Mapping of form fields to user-friendly names for future if needed
  private fieldNames: { [key: string]: string } = {
    //name: 'Name',
    //email: 'Email Address',
    //password: 'Password',
  };

  constructor() { }

  validateForm(form: FormGroup): string | null {
    const invalidFields: string[] = [];

    // Iterate over each control in the form group
    Object.keys(form.controls).forEach(field => {
      const control = form.get(field);
      if (control && control.invalid) {
        invalidFields.push(this.getErrorMessage(field, control));
      }
    });

    return invalidFields.length ? `Invalid fields:\n${invalidFields.join(',\n')}` : null;
  }

  private getErrorMessage(field: string, control: AbstractControl): string {
    const friendlyFieldName = this.fieldNames[field] || field.toUpperCase();

    if (control.errors) {
      if (control.errors['required']) {
        return `${friendlyFieldName} is required`;
      }
      if (control.errors['minlength']) {
        return `${friendlyFieldName} must be at least ${control.errors['minlength'].requiredLength} characters`;
      }
      if (control.errors['maxlength']) {
        return `${friendlyFieldName} must be no more than ${control.errors['maxlength'].requiredLength} characters`;
      }
      if (control.errors['pattern']) {
        return `${friendlyFieldName} has an invalid format`;
      }
      // Add more error checks as needed
    }
    return `${friendlyFieldName} is invalid`;
  }
}
